export const getWebSocketUrl = (url: string) =>
  url.replace(/^https?:\/\//, (match) =>
    match === 'https://' ? 'wss://' : 'ws://',
  );
